import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Aux from "./hoc/Auxiliary";
import * as actions from "../src/store/actions/index";
import { connect } from "react-redux";
import Login from "./components/Authenticate/Login/Login";
import SetYourPassword from "./components/Authenticate/SetYourPassword";
import Layout from "./container/Layout/Layout";
import jwtDecode from "jwt-decode";
import "./App.css";

function App(props) {
  const { isAuth, isTemporary } = props;

  const reload = () => {
    const token =
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user"))["accessToken"];
    if (token === null) {
      return;
    }
    window.location.reload();
  };

  let routes;

  if (isAuth === true && isTemporary === false) {
    const token =
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user"))["accessToken"];

    setTimeout(reload, (jwtDecode(token).exp - jwtDecode(token).iat) * 1000);

    routes = (
      <Aux>
        <Route path="/" component={Layout} />
        <Redirect to="/" />
      </Aux>
    );
  } else if (isAuth === false && isTemporary === true) {
    routes = (
      <Aux>
        <Route path="/set-your-password" component={SetYourPassword} />
      </Aux>
    );
  } else {
    routes = (
      <Aux>
        <Route path="/" component={Login} />
        <Redirect to="/" />
      </Aux>
    );
  }

  return (
    <div className="App">
      <Aux>
        <Switch>{routes}</Switch>
      </Aux>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state.auth,
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authorize: (isAuthBool) => {
      dispatch(actions.authorizeValidation(isAuthBool));
    },

    editMapState: (mapPayload) => {
      dispatch(actions.editMapState(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
